import { render, staticRenderFns } from "./FamilyInput.vue?vue&type=template&id=01d03a54&scoped=true&"
import script from "./FamilyInput.vue?vue&type=script&lang=js&"
export * from "./FamilyInput.vue?vue&type=script&lang=js&"
import style0 from "./FamilyInput.vue?vue&type=style&index=0&id=01d03a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d03a54",
  null
  
)

export default component.exports